import { gql, TypedDocumentNode } from "@apollo/client";

import {
  InitializeStreamMutation,
  InitializeStreamMutationVariables,
} from "./InitializeStream.generated";

const INITIALIZE_STREAM: TypedDocumentNode<
  InitializeStreamMutation,
  InitializeStreamMutationVariables
> = gql`
  mutation InitializeStream($taskUuid: String!) {
    initializeStream(taskUuid: $taskUuid) {
      ok
    }
  }
`;

export default INITIALIZE_STREAM;
